interface DetailResponse {
  response?: { data?: { detail?: unknown } }
}

/**
 * The `detail` DRF puts on a 4xx, or `fallback`.
 *
 * DRF sends a string for most errors but a list when a serialiser field
 * rejected the value, so both shapes have to be handled or the user sees
 * `["May not be blank."]`.
 */
export function apiErrorDetail(error: unknown, fallback: string): string {
  const detail = (error as DetailResponse).response?.data?.detail
  if (Array.isArray(detail) && detail.length > 0) return String(detail[0])
  if (typeof detail === 'string') return detail
  return fallback
}
